import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import StyledCard from "./styles";
import { getDocsURL } from "../../utilities";
import parse from "html-react-parser";
import Statedropdown from "../Statedropdown";

export default function Card({
  title,
  content,
  links,
  expandableItems,
  xs = "",
  sm = "",
  md = "",
  lg = "",
  xl = "",
  xxl = "",
  smallHeaderImage,
  bigHeaderImage,
  cardSize = "small",
}) {
  const isDpaCard = title === "Down Payment Assistance Programs";
  const isGovtGuidelinesCard = title === "Government Product Guidelines";
  const isConventionalGuidelinesCard = title === "Conventional Product Guidelines";

  const [showExpandable, setShowExpandable] = useState(false);

  const handleGuidelinesClick = (e) => {
    if (isGovtGuidelinesCard || isConventionalGuidelinesCard) {
      e.preventDefault();
      setShowExpandable(true);
    }
  };

  const handleBackClick = () => {
    setShowExpandable(false);
  };

  return (
    <StyledCard
      xs={xs}
      sm={sm}
      md={md}
      lg={lg}
      xl={xl}
      xxl={xxl}
      className={`card-col ${cardSize}`}
      $smallHeaderImage={smallHeaderImage}
      $bigHeaderImage={bigHeaderImage}
      $isDpaCard={isDpaCard}
    >
      <div className="card-box">
        <div className="card-title-box">
          <h6 className="card-title">{parse(title || "")}</h6>
        </div>
        <div className="card-content-box">
          {/* Show original content and links if not showing expandable items */}
          {!showExpandable && (
            <>
              <div className="card-content">{parse(content || "")}</div>
              {isDpaCard && <Statedropdown />}
              <ul>
                {links?.map((linkData, idx) => {
                  const { displayText, fileName, href } = linkData;
                  const docLink = fileName ? getDocsURL(fileName) : href;

                  // Intercept Guidelines click for Government Product Guidelines
                  if (
                    (isGovtGuidelinesCard || isConventionalGuidelinesCard) &&
                    (displayText === "Guidelines" ||
                    displayText === "Conventional product guidelines") &&
                    !fileName
                  ) {
                    return (
                      <li key={idx}>
                        <a
                          className="card-link"
                          href="#"
                          onClick={handleGuidelinesClick}
                        >
                          {parse(displayText)}
                        </a>
                      </li>
                    );
                  }

                  return (
                    <li key={idx}>
                      <a
                        className="card-link"
                        href={docLink}
                        target="_blank"
                        rel="noreferrer"
                        title={displayText}
                      >
                        {parse(displayText)}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </>
          )}

          {/* Show expandable items and a Back button */}
          {(isGovtGuidelinesCard || isConventionalGuidelinesCard) && showExpandable && Array.isArray(expandableItems) && (
            <>
              <ul className="expandable-items">
                {expandableItems.map((item, index) => (
                  <li key={index}>
                    <a
                      className="card-link"
                      href={getDocsURL(item.fileName)}
                      target="_blank"
                      rel="noreferrer"
                      title={item.displayText}
                    >
                      {parse(item.displayText)}
                    </a>
                  </li>
                ))}
              </ul>
              <Button
                className="card-back-button"
                onClick={handleBackClick}
              >
                ← Back
              </Button>
            </>
          )}
        </div>
      </div>
    </StyledCard>
  );
}
